import { MentorshipNavigationItem } from '../common/navigation';

export const MENTEE_NAVIGATION: MentorshipNavigationItem[] = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'workspace', label: 'Workspace' },
  { key: 'programs', label: 'Programs' },
  { key: 'profile', label: 'My Profile', icon: 'mentee' },
  { key: 'resources', label: 'Resources' },
  { key: 'notifications', label: 'Notifications' },
  { key: 'chat', label: 'Chat' },
];
